import { OverigPakket, Pakket } from "./pakketInfo";

export const pakketten: Pakket[] = [
  {
    title: "1",
    perks: ["10 Rijlessen €60,- per les", "Praktijk examen AVB & AVD"],
    price: "1180",
  },
  {
    title: "2",
    perks: ["15 Rijlessen €58,- per les", "Praktijk examen AVB & AVD"],
    price: "1450",
  },
  {
    title: "3",
    perks: ["20 Rijlessen €56,- per les", "Praktijk examen AVB & AVD"],
    price: "1700",
  },
  {
    title: "4",
    perks: ["25 Rijlessen €54,- per les", "Praktijk examen AVB & AVD"],
    price: "1930",
  },
  {
    title: "5",
    perks: ["35 Rijlessen €52,- per les", "Praktijk examen AVB & AVD"],
    price: "2400",
  },
];

export const overigePakketten: OverigPakket[] = [
  {
    title: "AVB examen",
    price: "230",
  },
  {
    title: "AVD examen",
    price: "350",
  },
  {
    title: "Proefles 90 minuten",
    price: "58",
  },
  {
    title: "Losse les",
    price: "60",
  },
];
